var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.goal && _vm.initialized)?_c('ActivityResultForm',{attrs:{"activity-object":_vm.activity,"goal-object":_vm.goal,"attachment-option":_vm.attachmentOption},on:{"onClickSave":_vm.registerActivity,"onClickDraft":_vm.registerDraft}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }